import { DrawerContentComponentProps } from "@react-navigation/drawer"
import { View, Text, FlatList, StyleSheet, SafeAreaView, TouchableOpacity, Platform, Image } from "react-native"
import { COLORS, ROUTES } from "../constants"
import { useState } from "react"
import LetterIcon from '../assets/images/letter.svg'
import { Icon } from "../lib/Icon"
// import PresentationIcon from '../assets/images/presentation.svg'
import FavoriteOffIcon from '../assets/images/favorite-off.svg'
import DownloadIcon from '../assets/images/download.svg'

type ItemData = {
  icon: any;
  slug: string;
  title: string;
};

const typesItems: ItemData[] = [
  { icon: (<Icon><LetterIcon /></Icon>), slug: ROUTES.HOME_DRAWER, title: 'Letras' },
  // { icon: <PresentationIcon />, slug: ROUTES.PRESENTATION_DRAWER, title: 'Presentación' },
];

const optionsItems: ItemData[] = Platform.OS === 'web' ? [
  { icon: <Icon><FavoriteOffIcon /></Icon>, slug: ROUTES.FAVORITE_DRAWER, title: 'Mis favoritos' },
] : [
  { icon: <Icon><FavoriteOffIcon /></Icon>, slug: ROUTES.FAVORITE_DRAWER, title: 'Mis favoritos' },
  { icon: <Icon><DownloadIcon /></Icon>, slug: ROUTES.DOWNLOAD_DRAWER, title: 'Mis descargas' },
];

type ItemProps = {
  item: ItemData;
  onPress: () => void;
  selected: boolean;
};

const Item = ({item, onPress, selected}: ItemProps) => (
  <TouchableOpacity onPress={onPress} style={[stylesItem.item]}>
    {item.icon}
    <Text style={[
      stylesItem.title,
      { fontFamily: selected ? 'Poppins' : 'Poppins' }
    ]}>{item.title}</Text>
  </TouchableOpacity>
);

const stylesItem = StyleSheet.create({
  item: {
    paddingHorizontal: 15,
    paddingVertical: 10,
    flexDirection: 'row',
    alignItems: 'center'
  },
  title: {
    fontSize: 18,
    fontWeight: '400',
    fontFamily: 'Poppins',
    marginLeft: 10,
    color: COLORS.white
  },
});

function CustomDrawer (props: DrawerContentComponentProps) {
  const [selectedId, setSelectedId] = useState<string>();

  const renderItem = ({item}: {item: ItemData}) => {
    const selected = item.slug === selectedId;

    const selectItem = () => {
      setSelectedId(item.slug)
      props.navigation.navigate(item.slug)
    }

    return (
      <Item
        item={item}
        onPress={selectItem}
        selected={selected}
      />
    );
  };
  
  return (
    <View style={stylesDrawer.container}>
      <SafeAreaView style={{ flex: 1 }}>
        <View style={stylesDrawer.header}>
          <Image source={require('../assets/logo.png')} style={stylesDrawer.logo} />
          <Text style={stylesDrawer.title}>Himnario Juvenil</Text>
        </View>
        <View style={{ flex: 1 }}>
          <View style={stylesDrawer.types}>
            <FlatList
              data={typesItems}
              renderItem={renderItem}
              keyExtractor={item => item.slug}
              extraData={selectedId}
            />
          </View>
          <View style={stylesDrawer.options}>
            <FlatList
              data={optionsItems}
              renderItem={renderItem}
              keyExtractor={item => item.slug}
              extraData={selectedId}
            />
          </View>
        </View>
      </SafeAreaView>
    </View>
  )
}

const stylesDrawer = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: COLORS.primary
  },
  header: {
    padding: 0,
    borderBottomColor: COLORS.border,
    borderBottomWidth: 1,
    height: 50,
    flexDirection: 'row',
    alignItems: 'center'
  },
  logo: {
    width: 32,
    height: 32,
    marginLeft: 10
  },
  title: {
    fontSize: 22,
    paddingStart: 5,
    // paddingTop: 5,
    fontFamily: 'PoppinsBold',
    color: COLORS.white
  },
  types: {
    borderBottomColor: COLORS.border,
    borderBottomWidth: 1,
    paddingVertical: 10
  },
  options: {
    paddingVertical: 10
  },
});

export default CustomDrawer
